export const frontend = ['HTML', 'React', 'JavaScript']
export const backend = ['Express', 'Python']